module.exports = __webpack_public_path__ + "media/images/sebastiao_a_pensar-4a8a78771fd403ce1565bb03a8d6b320.png";